// Turns the raw Sanity response into the shapes the components render.
// `imageUrl` is injected so this module stays free of the Sanity SDK.

const toNamedList = (items, getName) =>
  (items || []).map((item) => ({ id: item._id, name: getName(item) }));

export const normalizePortfolio = (raw, imageUrl) => {
  const profile = raw?.profile;
  if (!profile) {
    throw new Error('Sanity has no "profile" document yet.');
  }

  const social = (key) => ({
    link: profile[key]?.url || "",
    username: profile[key]?.username || "",
  });

  return {
    name: profile.name,
    role: profile.role,
    profileImageUrl: profile.profileImage
      ? imageUrl(profile.profileImage, { width: 1200 })
      : "",
    cvLink: profile.cvFileUrl || profile.cvUrl || "",
    aboutBio: profile.bio || [],
    hobbies: toNamedList(raw.hobbies, (item) => item.name),
    skills: toNamedList(raw.skills, (item) => item.name),
    education: toNamedList(raw.education, (item) => item.institution),
    experience: (raw.experience || []).map((job) => ({
      id: job._id,
      name: job.company,
      duration: job.duration,
    })),
    contacts: (profile.contacts || []).map((contact) => ({
      id: contact._key,
      type: contact.type,
      name: contact.value,
    })),
    socials: {
      github: social("github"),
      linkedin: social("linkedin"),
      twitter: social("twitter"),
      instagram: social("instagram"),
    },
    certificates: (raw.certificates || []).map((cert) => ({
      id: cert._id,
      alt: cert.title,
      url: imageUrl(cert.image, { width: 1200 }),
    })),
    projects: (raw.projects || []).map((project) => ({
      id: project._id,
      name: project.name,
      description: project.description,
      link: project.link,
      tech: project.tech,
      imageUrl: project.image ? imageUrl(project.image, { width: 1000 }) : "",
    })),
  };
};
